import { useTranslation } from 'next-i18next/pages'
import { useTheme } from 'styled-components'

import { TabularNums } from '../../../Typography/TabularNums'
import { useCountdown } from '../../useCountdown'

import {
  StyledContainer,
  StyledCountdownContainer,
  StyledCountdownDescriptionTypography,
  StyledCountdownTypography,
  StyledCtaButton,
  StyledWrapper,
} from './Countdown.Styled'

type Props = {
  expirationMillis?: number
  onCtaClick?: () => void
}

export const Countdown = ({ expirationMillis, onCtaClick }: Props) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const formattedTime = useCountdown(expirationMillis || 0)

  return (
    <StyledWrapper>
      <StyledContainer>
        <StyledCountdownContainer>
          <StyledCountdownDescriptionTypography
            $color={theme.colors['N Content/Primary']}
            $variant="Poppins/T4"
          >
            {t('paywall_discount_reserved')}
          </StyledCountdownDescriptionTypography>
          <StyledCountdownTypography
            $color={theme.colors['N Content/Highlighted']}
            $variant="Poppins/T1 - Semibold"
          >
            <TabularNums value={formattedTime} />
          </StyledCountdownTypography>
        </StyledCountdownContainer>
        <StyledCtaButton
          isDisabled={!onCtaClick}
          maxWidth="50%"
          onClick={onCtaClick}
        >
          {t('paywall_cta_get_my_plan')}
        </StyledCtaButton>
      </StyledContainer>
    </StyledWrapper>
  )
}
